import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilLockLocked, cilUser } from '@coreui/icons';
import { login } from 'src/services/Login';
import ls from 'local-storage';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/App';

const Login = () => {
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);

  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [toaster, setToaster] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (ls.get('token') && ls.get('userDetail')) {
      navigate('/dashboard');
    }
  }, []);

  async function handleLogin() {
    const response = await login(phone, password);

    // ls.set("partnerID", response.partnerID)

    if (response['success'] === 1) {
      setSuccess(true);
      setToaster('Logged In');
      ls.set('userDetail', response.user);
      ls.set('eToken', response.token);
      await Auth.fetchPermissions();
      navigate('/dashboard', { state: 'login success' });
    } else {
      setToaster(response.message);
      setTimeout(() => {
        setToaster('');
        // setDisabledButton(false)
      }, 1500);
    }
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Email / Phone"
                        autoComplete="phone"
                        value={phone}
                        onChange={(e) => {
                          setPhone(e.target.value);
                        }}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          className="px-4"
                          onClick={() => {
                            handleLogin();
                          }}
                          style={{
                            backgroundColor: '#4E5B97',
                            border: 'none'
                          }}
                        >
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              {/* <CCard className="text-white bg-primary py-5" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                      tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                    <Link to="/register">
                      <CButton color="primary" className="mt-3" active tabIndex={-1}>
                        Register Now!
                      </CButton>
                    </Link>
                  </div>
                </CCardBody>
              </CCard> */}
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>

      {toaster !== '' ? (
        <div
          style={{
            backgroundColor: 'white',
            height: '13vh',
            position: 'fixed',
            overflow: 'hidden',
            bottom: '30px',
            width: '20vw'
          }}
        >
          <div
            style={{
              dsiplay: 'flex',
              flexWrap: 'wrap',
              border: 'solid 0.5px',
              borderRadius: '7px',
              borderColor: 'silver',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <div
              style={{
                flexBasis: '25%',
                height: '25%',
                backgroundColor: success ? 'green' : 'red',
                width: '100%'
              }}
            >
              {/* <p style={{color:"red", textAlign:"left"}}>Gagal</p> */}
            </div>
            <div style={{ flexBasis: '75%' }}>
              <p style={{ color: 'black', textAlign: 'center' }}>{toaster}</p>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Login;
